import PropTypes from 'prop-types'
import React from 'react'
import { wrapFontFamily } from 'common/components/entities/Text/utils'
import { TriggeredPopup } from 'publisher/pages/components/triggered-popup'
import { usePage } from 'publisher/store'
import pageSelectors from 'publisher/store/page/pageSelectors'
import Meta from '../../components/core/Meta'
import { OnExitPopup } from '../components/on-exit-popup'
import { OnloadPopups } from '../components/onload-popups'
import PageUi from '../ui/PageUi'

function UpsellPage({ children }) {
  const globalTextFontProperties = usePage(
    pageSelectors.getGlobalFontProperties,
  )
  return (
    <PageUi
      $textFontFamily={wrapFontFamily(globalTextFontProperties.fontFamily)}
      $textFontWeight={globalTextFontProperties.fontWeight}
      $textFontStyle={globalTextFontProperties.fontStyle}
    >
      <Meta />
      {children}
      <TriggeredPopup />
      <OnExitPopup />
      <OnloadPopups />
      <div id="mercado-pago-dialog" />
    </PageUi>
  )
}

UpsellPage.propTypes = {
  children: PropTypes.node.isRequired,
}

export default UpsellPage
